import { Star as MuiStar } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import StrapiImage from '@/components/StrapiImage/StrapiImage';

import {
  ImageWrapper,
  LogoWrapper,
  TileVoice,
  TileWrapper,
} from './TestimonialTile.style';

const TestimonialTile = ({
  title,
  text,
  logo,
  image,
  customerName,
  jobTitle,
}) => {
  const logoData = logo?.data;

  return (
    <TileWrapper data-test-subject="testimonial-tile" variant="outlined">
      <Stack direction="column" gap={1}>
        <Stack direction="row">
          {Array.from(new Array(5)).map((_, idx) => (
            <MuiStar key={idx} color="secondary" />
          ))}
        </Stack>
        <Typography variant="h5" component="span" color="primary.dark">
          {title}
        </Typography>
        {image?.attributes?.url && (
          <ImageWrapper>
            <StrapiImage data={image} />
          </ImageWrapper>
        )}
        <TileVoice variant="body1">{text}</TileVoice>
        <LogoWrapper>
          {logoData?.attributes?.url && <StrapiImage data={logoData} fill />}
        </LogoWrapper>
        <Stack direction="column">
          <Typography variant="body1">{customerName}</Typography>
          <Typography variant="body2">{jobTitle}</Typography>
        </Stack>
      </Stack>
    </TileWrapper>
  );
};

TestimonialTile.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  logo: PropTypes.shape({
    data: PropTypes.shape({
      attributes: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }).isRequired,
    }),
  }).isRequired,
  image: PropTypes.shape({
    attributes: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired,
  }),
  customerName: PropTypes.string,
  jobTitle: PropTypes.string,
};

export default TestimonialTile;
